module.exports = __webpack_public_path__ + "h5/img/5.28fb8e94.png";